/* assets/simulator.js
 * iFace 統合シミュレーター（1本化）
 *
 * 旧: magsafe-simulator.js / firstclass-simulator.js / bebling2-simulator.js を統合。
 * 表示モードはマウント先 #sim_app の data 属性で切り替える。
 * data 属性がない場合は、旧 simulator.html と同じ URL クエリでも切り替える。
 *
 *   data-mode="magsynq"                → 旧 ?magsynq=true
 *   data-mode="panel"                  → 旧 ?panel
 *   data-mode="series" data-series="X" → 旧 ?series=X
 *   （data-mode 未指定 → 全ステップ表示）
 *
 * 商品・色・画像データは assets/simulator-data.json（window.SIMULATOR_DATA_URL）で一元管理。
 */
(function () {
  window.IfaceSimulator = window.IfaceSimulator || {};

  window.IfaceSimulator.init = function initIfaceSimulator() {
    // 二重初期化防止（モーダル開閉・再描画対策）
    if (window.IfaceSimulator.__inited) return;

    var root = document.getElementById("sim_app");
    if (!root) return; // 別ページで読み込まれても安全

    // 依存チェック
    if (!window.Vue || !window.axios) {
      console.error("[sim] Vue or axios not loaded:", {
        Vue: window.Vue,
        axios: window.axios,
      });
      return;
    }
    if (!window.Swiper) {
      console.error("[sim] Swiper not loaded:", window.Swiper);
      return;
    }

    window.IfaceSimulator.__inited = true;

    // ★ 合成PNGのベースパス
    const localSimulatorImageBasePath =
      "https://cdn.shopify.com/s/files/1/0978/9797/1991/files/";

    function resolveFilter(rootEl) {
      const dataMode = (rootEl.dataset.mode || "").trim();
      const dataSeries = (rootEl.dataset.series || "").trim();
      if (dataMode) return { mode: dataMode, seriesName: dataSeries };

      const params = new URLSearchParams(window.location.search);
      if (params.has("panel")) return { mode: "panel", seriesName: "" };
      if (params.get("magsynq") === "true") {
        return { mode: "magsynq", seriesName: "" };
      }
      if (params.has("series")) {
        return {
          mode: "series",
          seriesName: (params.get("series") || "").trim(),
        };
      }
      return { mode: "", seriesName: "" };
    }

    // ★ 旧URLパラメータ相当の表示モードを取得
    const filter = resolveFilter(root);
    const mode = filter.mode; // magsynq | panel | series | ""
    const seriesName = filter.seriesName; // 例: bebling2 / beblingWave

    const app = Vue.createApp({
      data() {
        return {
          items: [],
          items0: [], // 端末カラー
          items1: [], // ケース
          items2: [], // MagSynqアクセサリー
          items3: [], // ストラップ（現状は非表示運用）
          items4: [], // チャーム
          items5: [], // AirPods
          itemsp: [], // パネル
          itemsb: [], // バンパー
          clickitem: [],
          selectitem: {},
          step: "0",
          maxstep: 1,
          magsynq: true,
          mode: mode,
          seriesName: seriesName,
        };
      },

      mounted() {
        if (!window.SIMULATOR_DATA_URL) {
          console.error("[sim] SIMULATOR_DATA_URL not found");
          return;
        }

        axios
          .get(window.SIMULATOR_DATA_URL, { responseType: "json" })
          .then((res) => {
            const raw = Array.isArray(res.data) ? res.data : [];

            // 型の正規化（JSONは文字列なので数値/真偽へ）
            const normalized = raw.map((it) => ({
              ...it,
              step:
                it.step === "p" || it.step === "b" ? it.step : Number(it.step),
              magsynq: String(it.magsynq) === "true",
              series: (it.series || "").trim(),
              category: (it.category || "").trim(),
            }));

            this.part(normalized);
          })
          .catch((e) => console.log(e));
      },

      methods: {
        getProductThumbUrl(id) {
          return (
            localSimulatorImageBasePath +
            "pages-simulator-" +
            String(id) +
            ".png"
          );
        },
        getSimulatorImageUrl(fileName) {
          return (
            localSimulatorImageBasePath +
            "pages-system-simulator-" +
            String(fileName)
          );
        },

        // ★ モードごとの絞り込み（旧3ファイルのロジックを1本に統合）
        part(r) {
          if (!Array.isArray(r)) r = [];

          const mode = this.mode;
          const series = this.seriesName;

          let box0 = [],
            box1 = [],
            box2 = [],
            box3 = [],
            box4 = [],
            box5 = [],
            boxp = [],
            boxb = [];

          r.forEach(function (a) {
            if (mode === "magsynq") {
              // 旧 ?magsynq=true : 端末 / ケース(MagSafe対応のみ) / MagSynqアクセ
              if (a.step === 0) box0.push(a);
              else if (a.step === 1) {
                if (a.magsynq === true) box1.push(a);
              } else if (a.step === 2) box2.push(a);
            } else if (mode === "panel") {
              // 旧 ?panel : 端末 / パネル / バンパー / MagSynqアクセ
              if (a.step === 0) box0.push(a);
              else if (a.step === "p") boxp.push(a);
              else if (a.step === "b") boxb.push(a);
              else if (a.step === 2) box2.push(a);
            } else if (mode === "series" && series) {
              // 旧 ?series=X : 指定シリーズのアイテムに絞る
              if (a.step === 0) box0.push(a);
              else if (a.step === 1 && a.series === series) box1.push(a);
              else if (a.step === 2 && a.series === series) box2.push(a);
              else if (a.step === 3 && a.series === series) box3.push(a);
              else if (a.step === 4 && a.series === series) box4.push(a);
              else if (a.step === 5 && a.series === series) box5.push(a);
            } else {
              // モード未指定 : 全ステップ表示
              if (a.step === 0) box0.push(a);
              else if (a.step === 1) box1.push(a);
              else if (a.step === 2) box2.push(a);
              else if (a.step === 3) box3.push(a);
              else if (a.step === 4) box4.push(a);
              else if (a.step === 5) box5.push(a);
              else if (a.step === "p") boxp.push(a);
              else if (a.step === "b") boxb.push(a);
            }
          });

          this.items = r;
          this.items0 = box0;
          this.items1 = box1;
          this.items2 = box2;
          this.items3 = box3;
          this.items4 = box4;
          this.items5 = box5;
          this.itemsp = boxp;
          this.itemsb = boxb;

          // 表示ステップ数
          let count = 0;
          if (box0.length > 0) count++;
          if (box1.length > 0) count++;
          if (box2.length > 0) count++;
          if (box3.length > 0) count++;
          if (box4.length > 0) count++;
          if (box5.length > 0) count++;
          if (boxp.length > 0) count++;
          if (boxb.length > 0) count++;
          this.maxstep = count || 1;

          this.$nextTick(() => {
            this.swiper();
          });
        },

        swiper() {
          const SwiperCtor = window.Swiper;

          if (this._stepSwiperInstances && this._stepSwiperInstances.length) {
            this._stepSwiperInstances.forEach((ins) => {
              try {
                ins.destroy(true, true);
              } catch (e) {}
            });
          }
          this._stepSwiperInstances = [];

          document.querySelectorAll(".step-swiper").forEach((el) => {
            const ins = new SwiperCtor(el, {
              allowTouchMove: true,
              slidesPerView: "auto",
              spaceBetween: 0,
              speed: 700,
              centeredSlides: true,
              freeMode: true,
            });
            this._stepSwiperInstances.push(ins);
          });
        },

        select(e) {
          const item = e.target.dataset.item;
          const category = e.target.dataset.category;
          const group = e.target.dataset.group;
          const type = e.target.dataset.type;
          const index = parseInt(e.target.dataset.index, 10);

          const imagearea = document.getElementById(category);
          const multiimagearea = document.getElementById("magsynq_multi");
          const handstrap = document.getElementById("strap_hand");
          const strap = document.getElementById("strap");

          const eGroup = this[group];
          const eTarget = this[group] && this[group][index];
          if (!eTarget || !imagearea) return;

          if (type != undefined) {
            if (type.indexOf("_clear") != -1) {
              const multiimagetag =
                '<img src="' +
                this.getSimulatorImageUrl(item + "-multi.png") +
                '">';
              if (eTarget.isActive == true) multiimagearea.innerHTML = "";
              else multiimagearea.innerHTML = multiimagetag;
            } else {
              if (eTarget.step == 2) multiimagearea.innerHTML = "";
            }

            if (type.indexOf("handstrap") != -1) {
              const handimagetag =
                '<img src="' + this.getSimulatorImageUrl(item + ".png") + '">';
              if (eTarget.isActive == true) handstrap.innerHTML = "";
              else handstrap.innerHTML = handimagetag;
            } else {
              if (eTarget.step == 3) handstrap.innerHTML = "";
            }
          }

          if (eTarget.isActive == true) {
            imagearea.innerHTML = "";
            eTarget.isActive = false;
            delete this.selectitem[group];
          } else {
            if (type != undefined) {
              if (eTarget.step == 3 && type.indexOf("handstrap") == -1) {
                if (handstrap) handstrap.innerHTML = "";
                imageChange(item, imagearea);
              } else if (eTarget.step == 3 && type.indexOf("handstrap") != -1) {
                if (strap) strap.innerHTML = "";
              } else {
                imageChange(item, imagearea);
              }
            } else {
              imageChange(item, imagearea);
            }

            function imageChange(item, imagearea) {
              const imagetag =
                '<img src="' +
                localSimulatorImageBasePath +
                "pages-system-simulator-" +
                item +
                '.png">';
              imagearea.innerHTML = imagetag;
            }

            if (Array.isArray(eGroup))
              eGroup.forEach((v) => (v.isActive = false));
            eTarget.isActive = true;
            this.selectitem[group] = eTarget;
          }

          this.clickitem = eTarget;
          this.refresh();
          this.attention();
        },

        refresh() {
          const newdata = this.selectitem;
          const targets = document.querySelectorAll(".click_select");
          const active = document.querySelectorAll(".isActive");
          active.forEach((v) => v.classList.remove("isActive"));

          targets.forEach(function (v) {
            const id = v.getAttribute("data-item");
            const group = v.getAttribute("data-group");
            const selectgroup = newdata[group];
            if (selectgroup != undefined) {
              const selectid = selectgroup["id"];
              if (id != selectid) v.parentElement.classList.remove("isActive");
              else v.parentElement.classList.add("isActive");
            }
          });

          const scase = newdata.items1;
          if (scase) this.magsynq = scase.magsynq === true;
        },

        attention() {
          const click = this.clickitem || {};
          const clickactive = click.isActive;
          const target = document.getElementById("attention_area");
          if (!target) return;

          const a = target.querySelector(".item_attention1");
          const b = target.querySelector(".item_attention2");
          const c = target.querySelector(".item_link");

          target.classList.remove("show");
          a && a.classList.remove("show");
          b && b.classList.remove("show");
          c && c.classList.remove("show");
          if (a) a.innerHTML = "";
          if (b) b.innerHTML = "";
          if (c) c.href = "";

          if (clickactive == true) {
            if (click.attention1 != "") {
              target.classList.add("show");
              if (a) {
                a.classList.add("show");
                a.innerHTML = click.attention1;
              }
            }
            if (click.attention2 != "") {
              if (b) {
                b.classList.add("show");
                b.innerHTML = click.attention2;
              }
            }
            if (click.link != "") {
              if (c) {
                c.classList.add("show");
                c.href = click.link;
              }
            }
          }
        },

        next() {
          this.step = parseInt(this.step, 10) + 1;
          this.stepMove("n", parseInt(this.step, 10) + 1);
        },
        back() {
          this.step = parseInt(this.step, 10) - 1;
          this.stepMove("b", parseInt(this.step, 10) + 1);
        },

        stepMove(a, p) {
          const steps = document.querySelectorAll(".each_step");
          const newstep = steps[this.step];
          const oldstep = document.querySelector(".on_step");
          const pagenate = document.querySelector(".current_page");
          if (!newstep || !oldstep) return;

          oldstep.classList.remove("on_step");
          oldstep.classList.add("off_step");
          newstep.classList.remove("off_step");
          newstep.classList.add("on_step");
          if (pagenate) pagenate.innerHTML = p;
        },

        seeitem() {
          const el = document.getElementById("selectItem");
          if (el) el.classList.add("see");
        },
        closeitem() {
          const el = document.getElementById("selectItem");
          if (el) el.classList.remove("see");
        },
      },
    });

    app.mount("#sim_app");
    window.IfaceSimulator.__vueApp = app;
  };

  window.IfaceSimulator.onOpen = function () {};
  window.IfaceSimulator.onClose = function () {};
})();
